export default "__VITE_ASSET__29227195__$_#icon-ticket__"